export { SimplePageHeader } from './SimplePageHeader';
